var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "mb-3" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-8 offset-md-2 col-12" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body shadow-sm" }, [
            _c("h2", { staticClass: "text-center mt-2" }, [
              _vm._v(_vm._s(_vm.$t("message.scope_of_service")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c("img", {
                staticClass: "mr-3",
                attrs: {
                  src:
                    "https://beneat.s3.ap-southeast-1.amazonaws.com/services/ic_bathroom_cleaning.png",
                  width: "72"
                }
              }),
              _vm._v(" "),
              _c("h2", { staticClass: "my-auto" }, [
                _vm._v(_vm._s(_vm.$t("message.service.bathroom_cleaning")))
              ])
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "list-unstyled why-choose-us-list mt-3" }, [
              _c("li", [
                _c("i", {
                  staticClass: "fas fa-check-square -status-accepted"
                }),
                _vm._v(
                  "  " +
                    _vm._s(_vm.$t("message.booking_detail.solution_title00"))
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c("i", {
                  staticClass: "fas fa-check-square -status-accepted"
                }),
                _vm._v(
                  "  " +
                    _vm._s(_vm.$t("message.booking_detail.solution_title01"))
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c("i", {
                  staticClass: "fas fa-check-square -status-accepted"
                }),
                _vm._v(
                  "  " +
                    _vm._s(_vm.$t("message.booking_detail.solution_title02"))
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c("i", {
                  staticClass: "fas fa-check-square -status-accepted"
                }),
                _vm._v(
                  "  " +
                    _vm._s(_vm.$t("message.booking_detail.solution_title03"))
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c("i", {
                  staticClass: "fas fa-check-square -status-accepted"
                }),
                _vm._v(
                  "  " +
                    _vm._s(_vm.$t("message.booking_detail.solution_title04"))
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c("i", {
                  staticClass: "fas fa-check-square -status-accepted"
                }),
                _vm._v(
                  "  " +
                    _vm._s(_vm.$t("message.booking_detail.solution_title05"))
                )
              ])
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("h2", { staticClass: "text-center" }, [
              _c("i", { staticClass: "fas fa-check -status-accepted" }),
              _vm._v(
                " " +
                  _vm._s(_vm.$t("message.our_service.title")) +
                  "\n          "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "px-3" }, [
              _c("ul", { staticClass: "maininfo-list" }, [
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("message.bathroom_cleaning.condition01"))
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("message.bathroom_cleaning.condition02"))
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("message.bathroom_cleaning.condition03"))
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("message.bathroom_cleaning.condition04"))
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("message.bathroom_cleaning.condition05"))
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("message.bathroom_cleaning.condition06"))
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("message.bathroom_cleaning.condition07"))
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("message.bathroom_cleaning.condition08"))
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("message.bathroom_cleaning.condition09"))
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(_vm.$t("message.bathroom_cleaning.condition10"))
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("h2", { staticClass: "text-center" }, [
              _c("i", { staticClass: "fas fa-times -status-alert" }),
              _vm._v(
                " " +
                  _vm._s(_vm.$t("message.our_service.exclude_title")) +
                  "\n          "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "px-3" }, [
              _c("ul", { staticClass: "maininfo-list" }, [
                _c("li", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "message.bathroom_cleaning.not_covered_condition01"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "message.bathroom_cleaning.not_covered_condition02"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "message.bathroom_cleaning.not_covered_condition03"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "message.bathroom_cleaning.not_covered_condition04"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "message.bathroom_cleaning.not_covered_condition05"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "message.bathroom_cleaning.not_covered_condition06"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "message.bathroom_cleaning.not_covered_condition07"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "message.bathroom_cleaning.not_covered_condition08"
                      )
                    )
                  )
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "my-5" }, [_c("hr")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "my-5" }, [_c("hr")])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c09b228", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c09b228","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/components/BathroomCleaningServiceDetail.vue
// module id = 1872
// module chunks = 0